import { IMetricDTO } from './metric-dto.interface';

export interface IMetricListDTO {
  metrics: IMetricDTO[];
}